import { render, staticRenderFns } from "./TechnicalAlarm.vue?vue&type=template&id=263336b0&"
import script from "./TechnicalAlarm.vue?vue&type=script&lang=js&"
export * from "./TechnicalAlarm.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalAlarm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports